import { createEvent, createStore } from 'effector';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'pilgrim.theme';

const readStoredTheme = (): Theme => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'light' || raw === 'dark') return raw;
  } catch {
    /* private mode */
  }
  return 'light';
};

export const setTheme = createEvent<Theme>();

export const $theme = createStore<Theme>(readStoredTheme()).on(
  setTheme,
  (_, t) => t,
);
